/* eslint no-param-reassign: 0 */
/* eslint no-console: 0 */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const defaultState = () => ({
  project: null,
  hotspots: [],
  currentHotspot: false,
  playState: 0,
  duration: 0,
  currentTime: 0,
  loopEnabled: false,
  currentAttachment: null,
  playbackStarted: false,
  volume: 0,
  signedSecurity: false,
  playerReady: false,
  projectLoaded: false,
  regularVideoUrl: null,
  startTime: 0,
  autoPlay: false,
  muted: false,
  selectedQuality: null,
  appState: 'STARTED',
  unsupported: [],
  downlink: null,
  sitePassword: null,
});


const store = new Vuex.Store({
  state: defaultState(),
  mutations: {
    sitePassword(state, payload) {
      state.sitePassword = payload;
    },
    downlink(state, payload) {
      state.downlink = payload;
    },
    unsupported(state, payload) {
      Vue.set(state, 'unsupported', payload);
    },
    appState(state, payload) {
      state.appState = payload;
    },
    selectedQuality(state, payload) {
      state.selectedQuality = payload;
      Vue.set(state, 'selectedQuality', payload);
    },
    resetState(state) {
      Object.assign(state, defaultState());
    },
    muted(state, payload) {
      state.muted = payload;
      if (payload === true) state.volume = 0;
    },
    toggleMute(state) {
      state.muted = !state.muted;
    },
    autoPlay(state, payload) {
      state.autoPlay = payload;
    },
    startTime(state, payload) {
      state.startTime = payload;
    },
    regularVideoUrl(state, payload) {
      state.regularVideoUrl = payload;
      Vue.set(state, 'regularVideoUrl', payload);
    },
    projectLoaded(state, payload) {
      state.projectLoaded = payload;
    },
    playerReady(state, payload) {
      state.playerReady = payload;
    },
    signedSecurity(state, payload) {
      state.signedSecurity = payload;
    },
    volume(state, payload) {
      state.volume = payload;
    },
    playbackStarted(state, payload) {
      state.playbackStarted = payload;
    },
    project(state, payload) {
      state.project = payload;
    },
    hotspots(state, payload) {
      const computed = payload.map((hs) => {
        hs.completed = false;
        hs.timeStamp = hs.timeStamp || 0.2;
        hs.duration = hs.hasDuration ? hs.duration : 0.3;
        hs.pausesPlayBack = hs.pausesPlayBack || false;
        return hs;
      });

      state.hotspots = computed;
    },
    currentHotspot(state, payload) {
      state.currentHotspot = payload;
    },
    currentAttachment(state, payload) {
      const { attachmentUrl } = state.project;
      if (payload && attachmentUrl) {
        const url = `${attachmentUrl}${payload}`;
        state.currentAttachment = url;
      } else {
        state.currentAttachment = payload;
      }
    },
    customText(state, payload) {
      state.customText = payload;
    },
    hotspotDescription(state, payload) {
      state.hotspotDescription = payload;
    },
    playState(state, payload) {
      state.playState = payload;
    },
    duration(state, payload) {
      state.duration = payload;
    },
    currentTime(state, payload) {
      state.currentTime = payload;
    },
    loopEnabled(state, payload) {
      state.loopEnabled = payload;
    },
  },
  actions: {
  },
  getters: {
  },
});

export { store as default };
